export default "__VITE_ASSET__BUK1PEJn__"